import type { CalendarEvent } from 'owa-calendar-types';
import fetchCalendarEventsForDateRangeAndSubscribe from './fetchCalendarEventsForDateRangeAndSubscribe';
import type { DateRange } from 'owa-datetime-utils';
import type { LockedCalendarEventsStore } from 'owa-calendar-events-store';

export default function getCalendarEventsForDateRange(
    folderId: string,
    dateRange: DateRange,
    store: LockedCalendarEventsStore
): Readonly<CalendarEvent[]> | null {
    const { events, fetchPromise } = store.fetchCalendarEventsForDateRange(folderId, dateRange);
    if (!events) {
        fetchCalendarEventsForDateRangeAndSubscribe(folderId, dateRange, store, fetchPromise);
    }

    return events;
}
